const uiTypes = {
    SET_MENU_OPEN_STATUS: '[UI] SET_MENU_OPEN_STATUS',
    SET_MOBILE_MENU_OPEN_STATUS: '[UI] SET_MOBILE_MENU_OPEN_STATUS',
    CLEAR_DATA: '[UI] CLEAR_DATA',
};

export default uiTypes;
